import React from 'react';
import Button from './Button';
import { translate } from 'react-polyglot';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

const TRANSITION_START = 200;
const TRANSITION_STOP = 600;

const PreviewBadge = ({
  handlePublish,
  state: { is_preview, loading, publishing, published },
  t
}) =>
  <CSSTransitionGroup
    transitionName="slide"
    transitionEnterTimeout={TRANSITION_START}
    transitionLeaveTimeout={TRANSITION_STOP}
  >
    {is_preview &&
      !loading &&
      <div className="preview-badge">
        <div className="preview-badge__content">
          {t('quality_preview')}
        </div>

        <Button
          handleClick={e => {
            e.preventDefault();
            handlePublish();
          }}
          type={published ? 'sm btn--green' : 'sm'}
          text={
            publishing
              ? 'Publishing…'
              : published ? 'Published' : t('quality_publish')
          }
        />
      </div>}
  </CSSTransitionGroup>;

export default translate()(PreviewBadge);
